import axiosInstance from "./axios.instance";

export const UPDATE_PROFILE_PICTURE = async (payload) => {
       return await axiosInstance.post(`/image/waba/profilepic`,payload, {
    'accept': 'application/json',
    'Content-Type': `multipart/form-data`,
  });
}

export const GET_COMPANY_WABA_PROFILE = async () => await axiosInstance.get(`/company/waba/profile`);

export const UPDATE_COMPANY_WABA_PROFILE = async (payload) => {
    return await axiosInstance.put(`/company/waba/profile`, payload);
}
